/** The single time-zone constant until the active context carries the organisation's own. */
export const ORGANISATION_TIME_ZONE = 'Europe/Rome';

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

const formatter = new Intl.DateTimeFormat('it-IT', {
  timeZone: ORGANISATION_TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** The date and time parts of an instant in the organisation's zone, or null if unreadable. */
export function dateTimeParts(value: string): { date: string; time: string } | null {
  const instant = new Date(value);
  if (Number.isNaN(instant.getTime())) return null;
  const parts = formatter.formatToParts(instant);
  const get = (type: string) => parts.find((part) => part.type === type)?.value ?? '';
  return {
    date: `${get('day')}/${get('month')}/${get('year')}`,
    time: `${get('hour')}:${get('minute')}`,
  };
}

/**
 * «2026-10-09» → «09/10/2026» with no zone moving the day; an instant («2026-10-09T22:30:00Z»)
 * gives its day in the organisation's zone («10/10/2026»). Unreadable values come back as given.
 */
export function formatDate(value: string): string {
  const match = DATE_ONLY.exec(value);
  if (match !== null) return `${match[3]!}/${match[2]!}/${match[1]!}`;
  return dateTimeParts(value)?.date ?? value;
}

/** «2026-10-11T08:20:00Z» → «11/10/2026 10:20», in the organisation's time zone. */
export function formatDateTime(value: string): string {
  const parts = dateTimeParts(value);
  return parts === null ? value : `${parts.date} ${parts.time}`;
}
